export default __webpack_public_path__ + "static/media/Tabnavigation.1693106b.PNG";